// Fonte única dos itens de menu da sidebar, compartilhada entre 'Sidebar' e 'SpotlightSearch'
// para navegação. Mantida em módulo próprio para evitar dependência circular entre eles.

export interface INavbarItem {
  title: string
  icon?: string
  path: string
  roles: string[] // Empty array means item is visible to all roles
}

export interface INavbarGroup {
  title: string
  icon: string
  items: INavbarItem[]
}

export const navbarItems: (INavbarGroup | INavbarItem)[] = [
  {
    title: 'Dashboard',
    icon: 'lni lni-grid-alt',
    path: '/home',
    roles: []
  },
  {
    title: 'Agentes de IA',
    icon: 'custom:ai-sparkle',
    path: '/gems',
    roles: []
  },
  {
    title: 'Comercial',
    icon: 'lni lni-briefcase',
    items: [
      {
        title: 'Base de Leads',
        path: '/form-leads',
        roles: ['view_leads']
      },
      {
        title: 'Aulas Experimentais',
        path: '/aulas-experimentais',
        roles: ['view_experimental_class']
      },
      {
        title: 'Consultores Comerciais',
        path: '/consultores-comerciais',
        roles: ['view_consultants']
      },
      {
        title: 'Feriados e Plantões',
        path: '/feriados-e-plantoes',
        roles: ['view_holidays']
      },
      {
        title: 'Black List',
        icon: 'lni lni-ban',
        path: '/black-list',
        roles: ['view_blacklist']
      },
      {
        title: "Gerador de UTM's",
        icon: 'lni lni-link',
        path: '/url-shortener/commercial',
        roles: ['view_utms']
      },
      {
        title: 'Comprovantes de Vendas',
        icon: 'lni lni-files',
        path: '/comprovantes-de-vendas',
        roles: ['view_sales_receipts']
      },
      {
        title: 'Aproveitamento de Estudos',
        icon: 'lni lni-certificate',
        path: '/aproveitamento-de-estudos',
        roles: ['view_study_credit_requests']
      },
      {
        title: 'Comissão de Eventos',
        icon: 'lni lni-coin',
        path: '/comissao-de-eventos',
        roles: ['view_event_commissions']
      }
    ]
  },
  {
    title: 'Experiência do Aluno',
    icon: 'lni lni-graduation',
    items: [
      {
        title: 'Aulas Experimentais',
        path: '/aulas-experimentais',
        roles: ['view_experimental_class']
      },
      {
        title: 'Solicitações',
        path: '/solicitacoes',
        roles: ['view_requests']
      },
      {
        title: 'Video Quiz',
        path: '/video-quizes',
        roles: ['view_video_quizzes']
      },
      {
        title: 'Pesquisas de Satisfação',
        icon: 'lni lni-star-half',
        path: '/pesquisas-de-satisfacao',
        roles: ['view_surveys']
      },
      {
        title: 'Cronograma de Turmas',
        icon: 'lni lni-calendar',
        path: '/cronograma-de-turmas',
        roles: ['view_class_schedules']
      },
      {
        title: 'Comprovantes de Vendas',
        icon: 'lni lni-files',
        path: '/comprovantes-de-vendas',
        roles: ['view_sales_receipts']
      }
    ]
  },
  {
    title: 'Pedagógico',
    icon: 'lni lni-book',
    items: [
      {
        title: 'Entrega de Trabalhos',
        icon: 'lni lni-files',
        path: '/entrega-de-trabalhos',
        roles: ['view_assignments']
      },
      {
        title: 'Lista de Concursos',
        icon: 'lni lni-pointer',
        path: '/contests',
        roles: ['view_contests']
      },
      {
        title: 'Inscrições em Concursos',
        icon: 'lni lni-pointer',
        path: '/contests/applications',
        roles: ['view_contests_applications']
      },
      {
        title: 'Avaliação de Obras',
        icon: 'lni lni-brush-alt',
        path: '/contests/artwork-evaluation',
        roles: ['evaluate_contest_artworks', 'view_contest_votes']
      },
      {
        title: 'Aproveitamento de Estudos',
        icon: 'lni lni-certificate',
        path: '/aproveitamento-de-estudos',
        roles: ['view_study_credit_requests']
      }
    ]
  },
  {
    title: 'RH',
    icon: 'lni lni-users',
    items: [
      {
        title: 'Solicitações de MP',
        icon: 'lni lni-network',
        path: '/personnel-movement',
        roles: ['view_personnel_movement_requests', 'view_sector_personnel_movement_requests']
      },
      {
        title: 'Vagas de Emprego',
        icon: 'lni lni-clipboard',
        path: '/vagas-de-emprego',
        roles: ['view_job_requisitions', 'sign_job_requisitions']
      },
      {
        title: 'Banco de Talentos',
        icon: 'lni lni-network',
        path: '/job-applications',
        roles: ['view_talents']
      },
      {
        title: 'Admissão de Colaborador',
        icon: 'lni lni-user',
        path: '/admissoes',
        roles: ['view_admissions']
      },
      {
        title: 'Colaboradores',
        icon: 'lni lni-users',
        path: '/colaboradores',
        roles: ['view_employees']
      },
      {
        title: 'Cadastro de Cargos',
        icon: 'lni lni-briefcase',
        path: '/job-positions',
        roles: ['view_jobs']
      },
      {
        title: 'Professores',
        icon: 'lni lni-graduation',
        path: '/teachers',
        roles: ['view_teachers']
      }
    ]
  },
  {
    title: 'Feedback',
    icon: 'lni lni-thumbs-up',
    items: [
      {
        title: 'Acelera Magenta',
        icon: 'lni lni-ruler-pencil',
        path: '/acelera-magenta',
        roles: ['view_evaluations', 'view_sector_evaluations']
      },
      {
        title: 'Brilha Magenta',
        icon: 'lni lni-ruler-pencil',
        path: '/brilha-magenta',
        roles: ['view_evaluations_brilha', 'view_sector_evaluations_brilha']
      },
      {
        title: 'Conexão Magenta',
        icon: 'lni lni-ruler-pencil',
        path: '/conexao-magenta',
        roles: ['view_evaluations_conexao', 'view_sector_evaluations_conexao']
      },
      {
        title: 'Avaliação de Experiência',
        icon: 'lni lni-network',
        path: '/experience-feedback',
        roles: ['view_experience_feedbacks', 'view_sector_experience_feedbacks']
      }
    ]
  },
  {
    title: 'Marketing',
    icon: 'lni lni-bullhorn',
    items: [
      {
        title: "Gerenciador de URL's",
        icon: 'lni lni-link',
        path: '/url-shortener/marketing',
        roles: ['view_marketing_urls']
      },
      {
        title: 'Snippet de Contato',
        icon: 'lni lni-link',
        path: '/contact-code-generator',
        roles: ['view_contact_snippets']
      },
      {
        title: 'Vídeos de Depoimento',
        icon: 'lni lni-video',
        path: '/videos-de-depoimento',
        roles: ['view_testimonial_videos']
      }
    ]
  },
  {
    title: 'Financeiro',
    icon: 'lni lni-dollar',
    items: [
      {
        title: "Redirecionador de URL's",
        icon: 'lni lni-link',
        path: '/url-redirector/finances',
        roles: ['view_finance_redirectors']
      },
      {
        title: 'Reembolsos',
        icon: 'lni lni-link',
        path: '/refunds',
        roles: ['view_refunds', 'view_sector_refunds']
      },
      {
        title: 'Comprovantes de Vendas',
        icon: 'lni lni-files',
        path: '/comprovantes-de-vendas',
        roles: ['view_sales_receipts']
      },
      {
        title: 'Indicadores Financeiros',
        icon: 'lni lni-stats-up',
        path: '/financial-indicators',
        roles: ['edit_financial_indicators']
      }
    ]
  },
  {
    title: 'Eventos',
    icon: 'lni lni-calendar',
    items: [
      {
        title: 'Painel de Eventos',
        icon: 'lni lni-bookmark',
        path: '/events',
        roles: ['view_events']
      },
      {
        title: 'Cupons de Desconto',
        icon: 'lni lni-ticket',
        path: '/event-coupons',
        roles: ['view_coupons']
      },
      {
        title: 'Maquininhas',
        icon: 'lni lni-credit-cards',
        path: '/machines',
        roles: ['manage_machines']
      },
      {
        title: 'Comissão de Eventos',
        icon: 'lni lni-coin',
        path: '/comissao-de-eventos',
        roles: ['view_event_commissions']
      }
    ]
  },
  {
    title: 'Website',
    icon: 'lni lni-world',
    items: [
      {
        title: 'Banners',
        icon: 'lni lni-ruler-pencil',
        path: '/website-banners',
        roles: ['view_banners']
      },
      {
        title: 'Blog Posts',
        icon: 'lni lni-write',
        path: '/blog-posts',
        roles: ['view_posts']
      },
      {
        title: 'Cursos',
        icon: 'lni lni-bookmark',
        path: '/courses',
        roles: ['view_courses']
      },
      {
        title: 'Professores',
        icon: 'lni lni-graduation',
        path: '/teachers',
        roles: ['view_teachers']
      },
      {
        title: 'Alunos',
        icon: 'lni lni-pencil-alt',
        path: '/testimonials',
        roles: ['view_students']
      }
    ]
  },
  {
    title: 'Administração',
    icon: 'lni lni-cog',
    items: [
      {
        title: 'Usuários',
        icon: 'lni lni-users',
        path: '/users',
        roles: ['view_users']
      },
      {
        title: 'Grupos de Usuários',
        icon: 'lni lni-users',
        path: '/users-groups',
        roles: ['view_users']
      },
      {
        title: 'Setores',
        icon: 'lni lni-users',
        path: '/sectors',
        roles: ['view_sectors']
      }
    ]
  }
]
